import { useTranslation } from "@opendash/i18n";
import { Form, Input } from "antd";
import TextArea from "antd/es/input/TextArea";
import React from "react";
import FormItemProps from "../../../types/FormItemProps";

export default (props: FormItemProps) => {
  const t = useTranslation();

  return (
    <>
      <Form.Item
        label={t("maintenance:items.create.form.title.label")}
        name="title"
        rules={[
          {
            required: true,
            message: t("maintenance:items.create.form.title.rules.required"),
          },
        ]}
        initialValue={props.editItem?.name}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label={t("maintenance:items.create.form.description.label")}
        name="description"
        initialValue={props.editItem?.description}
      >
        <TextArea rows={4} />
      </Form.Item>
    </>
  );
};
